import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Section from '../Atoms/Section';
import BigH2 from '../Atoms/BigH2';
import BigH3 from '../Atoms/BigH3';
import InstagramWidgetTendance from '../Components/InstagramWidgetTendance';
import AnimatedSection from '../Components/AnimatedSection';
import BlueButton from '../Atoms/BlueButton';
import * as api from '../../api';

const VideoTitle = styled.h3`
  font-size: 18px;
  color: #333;
  width: 100%;
  /* border: 1px solid black; */
  margin: 0; /* Removes any default margin */
  display: flex;
  align-items: center; /* Vertically centers the text inside the title */
  justify-content: left; /* Horizontally centers the text */
  font-weight:bold;
  text-align: left;
  line-height: 1.5;
  min-height: calc(18px * 1.5 * 2);

  @media (max-width: 768px) {
 /* padding:10px; */
  }
`;

const VideoFrame = styled.iframe`
  width: 100%;
  height: 340px;
  border: none;
  /* flex-shrink: 0; Prevents iframe from resizing smaller */
  @media (max-width: 768px) {
    width: 100%;

  }
`;

const ResponsiveContainer = styled.div`
  text-align: center;
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-around;
  }
`;

const StyledSection = styled(Section)`
  /* padding: 40px; */
`;

const WebinarContainer = styled.div`
  display: flex;
  flex-direction: column; /* Default to column for smaller screens */
  align-items: center;
  gap: 20px;
  padding: 20px;
  margin-top: 30px;

  @media (min-width: 768px) {
    flex-direction: row; /* Switch to row layout on larger screens */
    justify-content: center;
    gap: 40px;
  }
`;
const VideoInfo = styled.div`
  display: flex;
  flex-direction: column; /* Title is below the video */
  align-items: center;
  justify-content: center;
  /* margin-top: 30px; */
  border: 1px solid;
  padding: 20px;
  border-top: none;
  width:100%;

`;
const WebinarWrapper = styled.div`
  display: flex;
  flex-direction: column; /* Title is below the video */
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 80%;
  text-align: center;

  @media (min-width: 768px) {
    width: 45%; /* Use 45% width for each video on larger screens */
  }
`;

const VideoDescription = styled.p`
  font-size: 14px;
  color: #555;
  margin-top: 10px;
  width: 100%;
  text-align: left;
`;

const WebinarFrame = styled.iframe`
  width: 100%; /* Responsive width */
  height: 340px; /* Fixed height for consistency */
  border: none;
`;

const Title = styled.div`
    width: 100%;
    border-bottom: 1px solid black;
    padding: 30px 0;
    text-align: left;
    padding-left:40px;
`;

const PDFLink = styled.a`
  width: 80%;
  
  @media (min-width: 768px) {
    width: 60%;
  }
`;

const InstagramContainer = styled.div`
  width: 80%;
  
  @media (min-width: 768px) {
    width: 30%;
  }
`;

const PressSection = styled(Section)`
  background-color: #f8f8f8;
  padding: 60px 20px;
`;

const PressGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 30px;
  max-width: 1200px;
  margin: 40px auto 0;
  padding-bottom: 20px;
  
  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (min-width: 1024px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

const PressCard = styled.a`
  display: flex;
  flex-direction: column;
  background: white;
  border: 1px solid #ddd;
  text-decoration: none;
  color: inherit;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  overflow: hidden;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  }
`;

const PressThumbnail = styled.div`
  width: 100%;
  height: 200px;
  background-color: #f0f0f0;
  background-image: url(${props => props.src});
  background-size: cover;
  background-position: center;
  border-bottom: 1px solid #ddd;
`;

const PressContent = styled.div`
  padding: 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const PressLogo = styled.img`
  height: 40px;
  width: auto;
  margin-bottom: 15px;
  object-fit: contain;
  display: block;
`;

const PressTitle = styled.h4`
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin: 0 0 20px 0;
  line-height: 1.3;
  text-align: center;
  flex: 1;
`;

const StyledBlueButton = styled(BlueButton)`
  margin: 0;
  font-size: 14px;
  padding: 8px 20px;
`;

const Actualités = () => {
  const [videos, setVideos] = useState({ interviewVideos: [], webinarVideos: [] });
  

  // Press articles data
  const pressArticles = [
    {
      id: 1,
      logoUrl: require('../../Components/img/maisonapart.png'),
      thumbnailUrl: require('../../Components/img/maisonapart-cahiers.webp'),
      title: 'Le French Design dévoile ses cahiers de style',
      preview: 'Découvrez les cahiers de style du French Design...',
      articleUrl: 'https://www.maisonapart.com/edito/s-inspirer/ambiances-et-styles/le-french-design-dvoile-ses-cahiers-de-style-14255.php'
    },
    {
      id: 2,
      logoUrl: require('../../Components/img/beauxartslogo.png'),
      thumbnailUrl: require('../../Components/img/5ft.jpg'),
      title: '8 galeries de design incontournables qui font vibrer Paris',
      preview: 'Découvrez les galeries de design parisiennes qui façonnent le paysage créatif de la capitale française...',
      articleUrl: 'https://www.beauxarts.com/lifestyle/8-galeries-de-design-incontournables-qui-font-vibrer-paris/?utm_medium=email&utm_term=N%2FA&utm_source=Ameublement-francais&utm_content=Revue%20de%20presse%20du%2023%20juin%202025&utm_campaign=SN%3A%20Revue%20de%20presse%20du%2023%20juin%2020%208c4c6c#msdynmkt_trackingcontext=e0f37528-6861-4572-88d4-8d6dd7d40300'
    },
    {
      id: 3,
      logoUrl: '/img/Logo_noir.png',
      thumbnailUrl: require('../../Components/img/designers-photo.jpg'),
      title: "Témoignage d'un adhérent : Louvry & Angioni",
      preview: 'Comment les créateurs français allient patrimoine artisanal et nouvelles technologies pour créer des pièces uniques...',
      articleUrl: '/milk-newsletter-2025'
    },
    {
      id: 4,
      logoUrl: require('../../Components/img/ad.jpg'),
      thumbnailUrl: require('../../Components/img/ad.webp'),
      title: 'Connected By, un réseau à la force de frappe internationale dans le monde du design',
      preview: 'Découvrez comment les designers français redéfinissent les codes esthétiques et fonctionnels dans l\'architecture d\'intérieur...',
      articleUrl: 'https://www.admagazine.fr/adactualites/promotion/connected-by-le-french-design-plateforme-design-francais'
    },
    {
      id: 5,
      logoUrl: require('../../Components/img/milkk.png'),
      thumbnailUrl: require('../../Components/img/milknewsletter.jpg'),
      title: "Témoignage d'un adhérent : Döppel Studio",
      preview: 'Le savoir-faire français en matière de design et d\'aménagement séduit de plus en plus de clients internationaux...',
      articleUrl: 'https://2iy.mj.am/nl3/8RTom-ypPbMFB6FJ3g9B9g?hl=fr'
    },
    {
      id: 6,
      logoUrl: require('../../Components/img/milkk.png'),
      thumbnailUrl: require('../../Components/img/milk.jpg'),
      title: 'Le FRENCH DESIGN : ConnectedBy, la plateforme bien pensée pour les professionnels du secteur',
      preview: 'Une analyse approfondie de l\'impact du design français sur le marché international du mobilier et de la décoration...',
      articleUrl: 'https://www.milkdecoration.com/le-french-design-connectedby-la-plateforme-bien-pensee-pour-les-professionnels-du-secteur/'
    },
    {
      id: 7,
      logoUrl: require('../../Components/img/dezeen.jpeg'),
      thumbnailUrl: require('../../Components/img/dzimg.jpg'),
      title: 'Le FRENCH DESIGN creates digital map to document French design troughout the world',
      preview: 'Creative platform Le French Design has launched a world map of showrooms and spaces around the world...',
      articleUrl: 'https://www.dezeen.com/2023/01/19/le-french-design-digital-map-french-design/'
    },
    {
      id: 8,
      logoUrl: require('../../Components/img/ad.jpg'),
      thumbnailUrl: require('../../Components/img/adimg.png'),
      title: 'Le FRENCH DESIGN WORLD MAP : la cartographie interactive de référencement du design français',
      preview: 'Véritable vitrine du design français et de son influence à travers le monde, Le FRENCH DESIGN WORLD MAP est une carte interactive...',
      articleUrl: 'https://www.admagazine.fr/promotion/le-french-design-world-map-la-cartographie-interactive-de-referencement-du-design-francais'
    },
  ];

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const {data : youtubeData} = await api.GetYoutubeData();
        
        if (youtubeData.interviews && youtubeData.webinaires) {
            const interviewVideos = youtubeData.interviews.slice(0, 2); // Take only the 2 latest videos
            const webinarVideos = youtubeData.webinaires.slice(0, 2); // Take only the 2 latest videos
            setVideos({ interviewVideos, webinarVideos });
        }
      } catch (error) {
        console.error('Error fetching videos:', error);
      }
    };

    fetchVideos();
  }, []);

  //there might be an anchor link to #on-parle-de-nous, if so, scroll to it after a 200ms delay, and scroll to 100px above the section
  useEffect(() => {
    const hash = window.location.hash;
    if (hash === '#on-parle-de-nous') {
      const section = document.getElementById('on-parle-de-nous');
      if (section) {
        setTimeout(() => {
          const sectionTop = section.getBoundingClientRect().top + window.scrollY - 50; // 100px above the section
          window.scrollTo({
            top: sectionTop,
            behavior: 'smooth'
          });
        }, 200); // Delay of 200ms before scrolling
      } else {
        console.warn('Section with id "on-parle-de-nous" not found');
      }
    }
  }, []);

  return (
    <div>
      <AnimatedSection direction="left" >
        <Title>
          <BigH2>TÉMOIGNAGES ET INTERVIEWS</BigH2>
        </Title>
      </AnimatedSection>
      <Section className='padding'>
        <BigH3 style={{marginLeft:'20px', marginTop:'20px'}} >Découvrez nos interviews ci-dessous</BigH3>
        <WebinarContainer>
          {videos.interviewVideos.map((video, index) => (
            <WebinarWrapper key={index}  reverse={index % 2 !== 0}>
              <VideoFrame
                src={video.embedUrl}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
              <VideoInfo>
                <VideoTitle>{video.title}</VideoTitle>
                <VideoDescription>{video.description}</VideoDescription>
              </VideoInfo>
            </WebinarWrapper>
          ))}
        </WebinarContainer>
        <a className='centered' href='/interviews'><BlueButton>Découvrez toutes nos interviews</BlueButton></a>
      </Section>
      <StyledSection>
        <AnimatedSection direction="right" delay={300}>
          <Title>
            <BigH2>CAHIERS DE STYLE</BigH2>
          </Title>
        </AnimatedSection>
        <AnimatedSection direction="left" delay={500}>
          <BigH3 style={{marginLeft:'40px', marginTop:'40px'}} >Les styles décryptés par nos experts</BigH3>
          <ResponsiveContainer>
  <PDFLink href="/cahiersdestyle">
    <img
      src="/documents/pdf-preview.png"
      alt="PDF Preview"
      style={{ border: '1px solid black', cursor: 'pointer' }}
    />
  </PDFLink>
  <InstagramContainer>
    <InstagramWidgetTendance/>
  </InstagramContainer>
</ResponsiveContainer>
<a style={{margin:'20px'}} className='centered' href='/cahiersdestyle'><BlueButton>Découvrez tous nos cahiers de style</BlueButton></a>
        </AnimatedSection>
      </StyledSection>
      <AnimatedSection 
        direction="up" 
        delay={200}
        threshold={0.1}  // Will trigger when 50% of the element is visible
      >
        <StyledSection>
          <Title>
            <BigH2 >WEBINAIRES</BigH2>
          </Title>
          <AnimatedSection 
            direction="left" 
            delay={400}
            threshold={0.5}  // Will trigger when 50% of the element is visible
          >
            <BigH3 style={{marginLeft:'40px', marginTop:'40px'}}>Découvrez les replays de nos webinaires, riches en astuces pratiques et ingénieuses</BigH3>
          </AnimatedSection>
          <WebinarContainer>
            {videos.webinarVideos.map((video, index) => (
              <WebinarWrapper key={index}>
                <WebinarFrame
                  src={video.embedUrl}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
                <VideoInfo>
              <VideoTitle>{video.title}
              </VideoTitle>
              <VideoDescription >
                    {video.description}
                  </VideoDescription>
                  </VideoInfo>
                              </WebinarWrapper>
            ))}
          </WebinarContainer>


          <a style={{margin:'20px'}} className='centered' href='/webinaires'><BlueButton>Découvrez tous nos webinaires</BlueButton></a>
      </StyledSection>
      </AnimatedSection>

      <AnimatedSection 
        direction="up" 
        delay={200}
        threshold={0.1}
      >
        <StyledSection id="on-parle-de-nous">
       
            <Title>
            <BigH2 >ON PARLE DE NOUS</BigH2>
          </Title>
          <PressGrid>
            {pressArticles.map((article) => (
              <PressCard 
                key={article.id} 
                href={article.articleUrl} 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <PressThumbnail src={article.thumbnailUrl} />
                <PressContent>
                  <PressLogo src={article.logoUrl} alt="Press logo" />
                  <PressTitle>{article.title}</PressTitle>
                  <StyledBlueButton>Lire l'article</StyledBlueButton>
                </PressContent>
              </PressCard>
            ))}
          </PressGrid>
        </StyledSection>
      </AnimatedSection>

    </div>
  );
};

export default Actualités;
